export enum CourseFormType {
    Individual = 1,
    Student = 2,
    Company = 3,
    Teacher = 4,
    XTraining = 5,
}
